import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { acceptedFilesAtom } from '../loads-page/core/LoadsImportSnackbar';
import { trackLoadsEvent } from './LoadsAnalytics';
import { useLaunchQueue } from 'shared/pwa/useLaunchQueue';
import { useNavigate } from 'react-router-dom';

export function useLoadsLaunchqueue() {
  const navigate = useNavigate();
  const setAcceptedFiles = useSetAtom(acceptedFilesAtom);

  const handleFilesReceived = useCallback(
    (files: File[]) => {
      setAcceptedFiles(files);
      navigate('/loads');
      trackLoadsEvent({
        name: 'Carrier Imported Load',
        utm_medium: 'file_handler',
      });
    },
    [setAcceptedFiles, navigate],
  );

  useLaunchQueue({
    onFilesReceived: handleFilesReceived,
  });
}
